const CLIO_EXPORT_MODAL_DISMISSED_KEY = 'clioExportModalDismissed';

export const isClioExportModalDismissed = () => {
  try {
    return localStorage.getItem(CLIO_EXPORT_MODAL_DISMISSED_KEY) === 'true';
  } catch {
    return false;
  }
};

export const setClioExportModalDismissed = () => {
  try {
    localStorage.setItem(CLIO_EXPORT_MODAL_DISMISSED_KEY, 'true');
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to save export modal preference:', error);
  }
};
